import { useEffect, useState } from 'react';

const KEY = 'findish_lang';

function readLang() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'kr' || v === 'en') return v;
  } catch {}
  return (navigator.language || '').startsWith('ko') ? 'kr' : 'en';
}

export default function useLanguage() {
  const [language, setLanguageState] = useState(readLang);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setLanguageState(readLang()); };
    const onCustom = () => setLanguageState(readLang());
    window.addEventListener('storage', onStorage);
    window.addEventListener('findish-lang-changed', onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('findish-lang-changed', onCustom);
    };
  }, []);

  const setLanguage = (next) => {
    const val = next === 'kr' ? 'kr' : 'en';
    try { localStorage.setItem(KEY, val); } catch {}
    setLanguageState(val);
    window.dispatchEvent(new Event('findish-lang-changed'));
  };

  return [language, setLanguage];
}
